<template>
  <div
    id="drop"
    class="px-16 pt-26"
  >
    <div class="d-flex justify-content-between position-relative" >
      <input
        :class="isOpen ? 'focus':''"
        type="input"
        value="Common Sizes"
        class="mb-7 text-gray-primary open-button"
        readonly
        @focus="gotFocus"
        @blur="loseFocus"
        @click="onClick"
        @select="clearTextSelection">
      <i
        class="fa-chevron-down icon-open fa "/>
      <span
        v-if="$store.getters['activeProduct/getIsVideoMoodOn']"
        class="tooltp d-flex align-items-center">?
        <div class="info">
          If you change the size of this page, all other pages will be adjusted to match the new dimensions. This might cause the overall design to change
        </div>
      </span>
      <div
        v-if="isOpen"
        class="dimension position-absolute" >
        <div class="container-Product-size">
          <div
            v-for="element in getProductSizes"
            class="dropdownhighlight__option--highlight"
            @mousedown.stop="changeProductSize(element)">

            <size-tag
              :id="element.id"
              :name="element.name==='Facebook'?'Facebook / LinkedIn':element.name"
              :size="(element.unit === 'Inches')?element.inches:element.size"
              :unit="element.unit"
              :is-favourite="element.isFavourite"/>
          </div>
        </div>

      </div>
      <div
        class="d-flex justify-content-center align-items-center"
        @click.stop="resetProductSize"> <icon name="rest"/></div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import Size from './Size';


export default {
  name:       'ProductPageSize',
  components: {
    'size-tag': Size,
  },
  data() {
    return {
      productSizes: [
        {
          id:          '1', name:        'Flyer', size:        '612 x 792', inches:      '8.5" x 11"', isFavourite: false, unit:        'Inches',
        },
        {
          id:          '2', name:        'Facebook', size:        '1200 x 628', inches:      '16.66" x 8.72"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '3', name:        'Twitter', size:        '1024 x 512', inches:      '14.22" x 7.11"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '4', name:        'Instagram', size:        '1080 x 1080', inches:      '15.00" x 15.00"', isFavourite: false, unit:        'Pixels',
        },
      ],
      isOpen: false,
      name:   'Common',
    };
  },
  computed: {
    getProductSizes() {
      const customSizes    = [
        {
          id:          '1', name:        'Flyer', size:        '612x792', inches:      '8.5" x 11"', isFavourite: false, unit:        'Inches',
        },
        {
          id:          '2', name:        'Facebook', size:        '1200x628', inches:      '16.66" x 8.72"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '3', name:        'Twitter', size:        '1024x512', inches:      '14.22" x 7.11"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '4', name:        'Instagram', size:        '1080x1080', inches:      '15.00" x 15.00"', isFavourite: false, unit:        'Pixels',
        },
      ];
      const sizeToReturn   = [];
      const favouriteSizes = this.$store.getters.getFavouriteSizes;
      if (favouriteSizes) {
        favouriteSizes.forEach((favouriteSize) => {
          sizeToReturn.push({
            id:   favouriteSize.Id,
            name: favouriteSize.Name,
            size: favouriteSize.Unit === 'Pixels' ? `${parseInt(favouriteSize.Width, 10)}x${parseInt(favouriteSize.Height, 10)}`
              : `${(parseFloat(favouriteSize.Width)) * 72} x ${(parseFloat(favouriteSize.Height)) * 72}`,
            inches:      `${parseFloat(favouriteSize.Width).toFixed(2)}" x ${parseFloat(favouriteSize.Height).toFixed(2)}"`,
            isFavourite: true,
            unit:        favouriteSize.Unit,
          });
        });
        return sizeToReturn.concat(customSizes);
      }
      return this.productSizes;
    },
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN, this.closeDropDown);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.closeDropDown);
  },
  beforeDestroy() {
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN, this.closeDropDow);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.closeDropDown);
  },
  methods: {
    onMouseDown() {
      console.log('mousedown');
    },
    clearTextSelection(e) {
      e.target.selectionStart = e.target.selectionEnd;
    },
    loseFocus(e) {
      this.$nextTick(() => {
        this.isOpen = false;
      });
    },
    onClick() {
      this.isOpen = !this.isOpen;
    },
    gotFocus() {
      console.log('Focus got');
      // this.isOpen = true;
    },
    resetProductSize() {
      // EventBus.$emit('setDefaultCropValue')
      this.name = 'Common';
      setTimeout(() => {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE);
      }, 0);
    },
    changeProductSize(object) {
      this.name = object.name;
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, object);
      this.isOpen = false;
    },
    closeDropDown() {
      this.isOpen = false;
    },
  },

};
</script>

<style  lang="scss" scoped>
    .dimension{
        z-index: 2;
        width: 244px;
        max-height: 590px;
        height: max-content;
        background: #FFFFFF;
        box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
      overflow: auto;
    }
    .custom-icon {
        font-size: 0px;
    }
   .dropdownhighlight__option--highlight:hover {
        background-color: #F7FCFF;
   }
    .dropdownhighlight__option--highlight:hover label.hover{
        color: $blue50 !important;
    }
    .container-Product-size{
        margin-top: 10px;
        margin-left: 7px;
        margin-right: 0px;
    }
    .padding{
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 5px;
        padding-right: 5px;
    }
    .mb-7.text-gray-primary:hover{
        cursor: pointer;
    }
    .dimension{
      top: 40px;
    }
    .open-button{
      font-size: 12px;
      user-select: none;
      border: solid thin transparent;
      width: 244px;
      padding: 5px 10px;
      box-shadow: inset 0px 0px 8px  #0000001a;
      border-radius: 3px;
      height: 34px;
      color:#5f5f5f;
      &.focus{
        border:solid thin #3bb0fa !important
      }
        &:hover{
        border: solid thin #BDBDBD;
      }
    }
    .icon-open{
      position: absolute;
      z-index: 10;
      top: 12px;
      left: 220px;
      pointer-events: none;
      color: #5f5f5f;
    }

    .tooltp{
      position: relative;
      font-size: 12px;
      color: black;
      .info{
        position: absolute;
        display: none;
        width: 180px;
        height: 110px;
        left: 50%;
        bottom: 81%;
        transform: translate(-74%);
        background-color: white;
        padding: 10px;
        border-radius: 5px;
        z-index: 99;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);

        &:after{
          content: "";
          display: block;
          bottom: -3px;
          height: 15px;
          width: 15px;
          background-color: white;
          right: 39px;
          transform: rotate(45deg);
          position: absolute;
        }
      }
      &:hover{
        .info{
          display: block;
      }
      }
    }

</style>
